export function addBigPlayButton(playerRef: any) {
  const player = playerRef;
  const playerEl = player.el();

  // Create the big play button container
  const bigPlayButton = document.createElement('button');
  bigPlayButton.className = 'vjs-big-play-button-custom';
  bigPlayButton.setAttribute('type', 'button');
  bigPlayButton.setAttribute('aria-label', 'Play');
  bigPlayButton.setAttribute('title', 'Play/Pause');

  // Create the icon container
  const iconContainer = document.createElement('div');
  iconContainer.className = 'big-play-button-icon';
  bigPlayButton.appendChild(iconContainer);

  // Add button to player
  playerEl.appendChild(bigPlayButton);

  // Function to update the button icon based on play state
  function updateButtonIcon() {
    if (player.paused()) {
      // Show play icon when paused
      iconContainer.innerHTML = `<img src="https://stcf-prod.zee5.com/prod/zee5Videojs/resources/images/play-hollow.svg" alt="Play" />`;
      bigPlayButton.classList.remove('playing');
      bigPlayButton.classList.add('paused');
    } else {
      // Show pause icon when playing
      iconContainer.innerHTML = `<img src="https://stcf-prod.zee5.com/prod/zee5Videojs/resources/images/pause.svg" alt="Pause" />`;
      bigPlayButton.classList.remove('paused');
      bigPlayButton.classList.add('playing');
    }
  }

  // Set initial icon (show pause since player will autoplay)
  updateButtonIcon();

  // Click handler - toggle play/pause
  bigPlayButton.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (player.paused()) {
      player.play();
      // Ensure the playing state is properly reflected
      player.removeClass('vjs-paused');
      player.addClass('vjs-playing');
    } else {
      player.pause();
      // Ensure the paused state is properly reflected
      player.addClass('vjs-paused');
      player.removeClass('vjs-playing');
    }
  });

  // Update icon on play/pause events
  player.on('play', updateButtonIcon);
  player.on('pause', updateButtonIcon);
  player.on('playing', updateButtonIcon);

  // Store reference for cleanup
  (player as any).bigPlayButtonElement = bigPlayButton;
  (player as any).updateBigPlayButtonIcon = updateButtonIcon;
}

export function removeBigPlayButton(playerRef: any) {
  const player = playerRef;
  const bigPlayButtonElement = (player as any).bigPlayButtonElement;

  if (bigPlayButtonElement) {
    player.off('play', (player as any).updateBigPlayButtonIcon);
    player.off('pause', (player as any).updateBigPlayButtonIcon);
    player.off('playing', (player as any).updateBigPlayButtonIcon);
    bigPlayButtonElement.remove();
  }
}
